import React, { useEffect, useState } from "react";
import * as validationService from "./validationService";
import * as modalDataService from "./modalDataService";
import { debug } from "../../utils";
import { connect } from "react-redux";

function WinRmPasswordField({ winrmPassword, centralCredential, error }) {

    const [disableValue, setDisableValue] = useState(false)

    useEffect(() => {
        if (centralCredential && centralCredential.id > 0) {
            validationService.cleanValidation('winrmPassword');
            onChange('');
            setDisableValue(true);
        } 
        else {
            validationService.validateNotEmpty(winrmPassword, 'winrmPassword');
            setDisableValue(false);
        }
        //validationService.validateNotEmpty(winrmPassword, 'winrmPassword');
        return () => validationService.cleanValidation('winrmPassword');
    }, [winrmPassword, centralCredential])


    const onChange = (value) => modalDataService.changeWinRmPassword(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="winrm_password-key">Password <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="winrm_password-key"
                    type="password"
                    disabled={disableValue}
                    value={winrmPassword}
                    placeholder="••••••••"
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("WinRmPasswordField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        winrmPassword: addDeviceModal.winrmPassword || '',
        centralCredential: addDeviceModal.centralCredential || null,
        error: validation.winrmPassword,
    }
}

export default connect(mapStateToProps)(WinRmPasswordField);
